
      import Finished from './finished.vue'
      import type { App, Plugin } from 'vue'

      export const FinishedPlugin: Plugin = {
        install(app: App) {
          app.component('Finished', Finished)
        },
      }
      export { Finished }
      